export const changeToTitleCase = (words) =>
    words ? words
        .split(' ')
        .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1).toLowerCase())
        .join(' ') : words;